<template>
  <div ref="Drawer">
    <a-drawer v-model:open="open" class="custom-class" root-class-name="root-class-name" :closable="false"
      placement="right" :width="'828px'" @after-open-change="afterOpenChange" @close="cancel"
      wrapClassName="drawer-style" :getContainer="() => Drawer">
      <template v-slot:title>
        <div>
          <img :src="require('@/assets/icons/bg_icon.png')" style="width: 25px; vertical-align: bottom" alt="" />

          <span class="ml10 first_title">{{ drawerTitle }}</span>
        </div>
      </template>
      <template #extra>
        <div class="back" @click="closeOpen">
          <a-button type="primary">
            <i class="iconfont icon-fanhuiicon mr5"></i>返回
          </a-button>
        </div>
      </template>
      <template v-if="drawerTitle != '报告详情'" #footer>
        <div class="botm">
          <a-button type="primary" ghost @click="cancelDrawer">取消</a-button>
          <a-button type="primary" style="margin-left: 61px" @click="confirm">确定</a-button>
        </div>
      </template>

      <div class="drawer_content">
        <div class="left_ant_right">
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '上传脱离报告'" class="left">
            测试牌照
          </div>
          <div v-if="drawerTitle === '报告详情'" class="right">
            {{ form.testCarNum }}
          </div>
          <div v-if="drawerTitle === '上传脱离报告'" class="right">
            <a-select v-model:value="form.carId" style="width: 380px" placeholder="请选择" @change="testCarNumChange">
              <a-select-option v-for="item in testCarNumList" :key="item.id" :value="item.id">{{ item.testCarNum
              }}</a-select-option>
            </a-select>
          </div>
        </div>

        <div class="left_ant_right">
          <div class="left">脱离时间</div>

          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.departureTimeStr }}
          </div>
          <div v-else class="right">
            <a-date-picker show-time placeholder="选择时间" style="width: 380px" format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss" v-model:value="form.departureTimeStr" />
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">脱离地点</div>
          <div v-if="drawerTitle === '报告详情' || drawerTitle === '完善报告'" class="right">
            {{ form.departurePoint }}
          </div>
          <div v-else class="right">
            <a-input style="width: 380px" v-model:value="form.departurePoint" placeholder="请输入" />
          </div>
        </div>
        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">脱离时场景分类</div>
          <div class="right">
            <a-radio-group v-model:value="form.departureScene" :disabled="drawerTitle === '报告详情' ? true : false"
              @change="radioChange">
              <a-radio v-for="(item, index) in departureScene" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}
                <div v-if="item.dataValue === '其他' && flag">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>

        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">脱离时主要交通参与者类型</div>
          <div class="right">
            <a-radio-group v-model:value="form.departureMajorParticipant"
              :disabled="drawerTitle === '报告详情' ? true : false" @change="radioChange2">
              <a-radio v-for="(item, index) in departureMajorParticipant" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}
                <div v-if="item.dataValue === '其他' && flag2">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput2" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">脱离时主要交通设施</div>
          <div class="right">
            <a-radio-group v-model:value="form.departureMajorFacility" :disabled="drawerTitle === '报告详情' ? true : false"
              @change="radioChange3">
              <a-radio v-for="(item, index) in departureMajorFacility" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}
                <div v-if="item.dataValue === '其他' && flag3">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput3" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right" style="margin-bottom: 0">
          <div class="left" style="margin-bottom: 24px">脱离类别</div>
          <div class="right">
            <a-radio-group :disabled="drawerTitle === '报告详情' ? true : false" v-model:value="form.departureCategory">
              <a-radio v-for="(item, index) in departureCategory" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue
              }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>

        <div class="left_ant_right" style="align-items: start; margin-bottom: 0">
          <div class="left">脱离原因</div>
          <div class="right">
            <a-radio-group v-model:value="form.departureReason" :disabled="drawerTitle === '报告详情' ? true : false"
              @change="radioChange4">
              <a-radio v-for="(item, index) in departureReason" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue
              }}
                <div v-if="item.dataValue === '其他' && flag4">
                  <input :disabled="drawerTitle === '报告详情' ? true : false" class="old_inp" type="text"
                    v-model="userInput4" />
                </div>
              </a-radio>
            </a-radio-group>
          </div>
        </div>

        <div class="left_ant_right">
          <div class="left">脱离情况详细说明</div>
          <div v-if="drawerTitle === '报告详情'" class="right">
            {{ form.departureDetailedDescription }}
          </div>
          <div v-else class="right">
            <a-input style="width: 380px" v-model:value="form.departureDetailedDescription" placeholder="请输入" />
          </div>
        </div>
        <div class="left_ant_right" style="margin-bottom: 0">
          <div class="left" style="margin-bottom: 24px">人工介入方式</div>
          <div class="right">
            <a-radio-group :disabled="drawerTitle === '报告详情' ? true : false" v-model:value="form.manualInterventionMode"
              style="margin-bottom: 0">
              <a-radio v-for="(item, index) in manualInterventionMode" :key="item.id" :value="item.dataCode + ''">{{
                item.dataValue }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>
        <div class="left_ant_right">
          <div class="left">脱离报告提交日期</div>

          <div v-if="drawerTitle === '报告详情'" class="right">
            {{ form.submitDateStr }}
          </div>
          <div v-else class="right">
            <a-date-picker show-time placeholder="选择时间" style="width: 380px" format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD" v-model:value="form.submitDateStr" />
          </div>
        </div>
        <!-- <div class="left_ant_right" style="margin-bottom: 26px">
          <div class="left">脱离视频</div>

          <div class="right">
            <video class="video-area-main-body" autoplay muted loop :src="form.videoUrls">
            </video>
          </div>

        </div> -->
        <div v-if="drawerTitle !== '报告详情'" class="message">
          申请主体承诺提交的材料真实有效，愿意承担相关法律责任
        </div>
      </div>
      <a-tabs style="margin-left: 60px;width:590px" v-model:activeKey="activeKey" class="tab-content-container" forceRender>
        <a-tab-pane :key="0" tab="车外">
          <div v-if="historyVideos && historyVideos.length > 0">
            <VideoPlayer
                v-for="(item, index) in historyVideos"
                :key="index"
                :src="item.outVideo || ''"
                :videoId="`dynamic-video-out-${index}`"
                className="video-area-main-body"
                :muted="true"
                :loop="true"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane :key="1" tab="车内">
          <div v-if="historyVideos && historyVideos.length > 0">
            <VideoPlayer
                v-for="(item, index) in historyVideos"
                :key="index"
                :src="item.inVideo || ''"
                :videoId="`dynamic-video-in-${index}`"
                className="video-area-main-body"
                :muted="true"
                :loop="true"
            />
          </div>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="刹车踏板">
          <div v-if="historyVideos && historyVideos.length > 0">
            <VideoPlayer
                v-for="(item, index) in historyVideos"
                :key="index"
                :src="item.breakVideo || ''"
                :videoId="`dynamic-video-break-${index}`"
                className="video-area-main-body"
                :muted="true"
                :loop="true"
            />
          </div>
        </a-tab-pane>
      </a-tabs>
    </a-drawer>
  </div>
</template>
<script setup>
import {
  ref,
  reactive,
  toRefs,
  onBeforeMount,
  onMounted,
  defineExpose,
  toRaw,
  defineProps,
  defineEmits,
  watch
} from "vue";
import { cloneDeep } from "lodash-es";
import { message } from "ant-design-vue";
import moment from "moment";
import { detail, getHistoryVideos } from "@/api/report/disengagement.js";
import { getCars } from "@/api/car/car.js";

import useUserStore from "@/store/modules/user";
const store = useUserStore();

import useAppStore from "@/store/modules/app";
import VideoPlayer from "@/components/videoPlayer/index.vue";
const appStore = useAppStore();

const dataType = "departureScene";
const dataType2 = "departureMajorParticipant";
const dataType3 = "departureMajorFacility";
const dataType4 = "departureCategory";

const dataType5 = "manualInterventionMode";
const dataType6 = "departureReason"


const Drawer = ref();
const props = defineProps({
  drawerTitle: {
    type: String,
    default: "",
  },
});

const open = ref(false);
const formRef = ref();

const form = ref({
  carId: undefined,
  departureTimeStr: "",
  departurePoint: "",
  departureScene: "1",
  departureMajorParticipant: "1",
  departureMajorFacility: "1",
  departureCategory: "1",
  departureDetailedDescription: "",
  manualInterventionMode: "1",
  departureReason: "1",
  submitDateStr: "",
  testCarNum: "",
  videoUrls: []
});

const historyVideos = ref([])

const userInput = ref("");
const departureScene = ref([]);
const activeKey = ref(0);

watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType);
      departureScene.value = val[index].children;
      console.log(departureScene.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const userInput2 = ref("");
const departureMajorParticipant = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType2);
      departureMajorParticipant.value = val[index].children;
      console.log(departureMajorParticipant.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const userInput3 = ref("");
const departureMajorFacility = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType3);
      departureMajorFacility.value = val[index].children;
      console.log(departureMajorFacility.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const departureCategory = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType4);
      departureCategory.value = val[index].children;
      console.log(departureCategory.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);

const manualInterventionMode = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType5);
      manualInterventionMode.value = val[index].children;
      console.log(manualInterventionMode.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);


const userInput4 = ref("");
const departureReason = ref([]);
watch(
  () => appStore.SysDictVOList,
  (val) => {
    console.log(val);
    if (val.length > 0) {
      const index = val.findIndex((item) => item.dataType === dataType6);
      departureReason.value = val[index].children;
      console.log(departureReason.value);
    }
  },
  {
    deep: true,
    immediate: true,
  }
);


const reset = () => {
  form.value = {
    carId: undefined,
    departureTimeStr: "",
    departurePoint: "",
    departureScene: "1",
    departureMajorParticipant: "1",
    departureMajorFacility: "1",
    departureCategory: "1",
    departureDetailedDescription: "",
    manualInterventionMode: "1",
    departureReason: "1",
    submitDateStr: "",
    testCarNum: "",
    videoUrls: [],
  };
  flag.value = false;
  flag2.value = false;
  flag3.value = false;
  flag4.value = false;
  userInput.value = "";
  userInput2.value = "";
  userInput3.value = "";
  userInput4.value = "";
};

const afterOpenChange = (bool) => {
  console.log("open", bool);
};

const testCarNumList = ref([]);
const getCarsData = () => {
  getCars({
    pageIndex: null,
    pageSize: null,
    conditionMap: {
      deptName: "",
      frameNum: "",
      testCarNum: "",
      deptIdStr: store.deptId,
    },
  }).then((res) => {
    console.log(res);
    if (res.code === 200) {
      testCarNumList.value = res.data.total;
    }
  });
};

const testCarNumChange = (value) => {
  console.log(value);
  let res = testCarNumList.value.find((item) => item.id === value);
  console.log(res);
  form.value.testCarNum = res.testCarNum;
};

const showDrawer = (data) => {
  open.value = true;
  reset();
  if (data) {
    console.log(data);
    detail({ id: data.id }).then((res) => {
      console.log(res);
      if (res.code === 200) {
        form.value = res.data;
        if (
          res.data.departureScene.indexOf("0_") != -1 ||
          res.data.departureScene.indexOf("0") != -1
        ) {
          flag.value = true;
          let arr = res.data.departureScene.split("_");
          console.log(arr);
          form.value.departureScene = arr[0];
          userInput.value = arr[1];
        }

        if (
          res.data.departureMajorParticipant.indexOf("0_") != -1 ||
          res.data.departureMajorParticipant.indexOf("0") != -1
        ) {
          flag2.value = true;
          let arr = res.data.departureMajorParticipant.split("_");
          console.log(arr);
          form.value.departureMajorParticipant = arr[0];
          userInput2.value = arr[1];
        }

        if (
          res.data.departureMajorFacility.indexOf("0_") != -1 ||
          res.data.departureMajorFacility.indexOf("0") != -1
        ) {
          flag3.value = true;
          let arr = res.data.departureMajorFacility.split("_");
          console.log(arr);
          form.value.departureMajorFacility = arr[0];
          userInput3.value = arr[1];
        }

        if (
          res.data.departureReason.indexOf("0_") != -1 ||
          res.data.departureReason.indexOf("0") != -1
        ) {
          flag4.value = true;
          let arr = res.data.departureReason.split("_");
          console.log(arr);
          form.value.departureReason = arr[0];
          userInput4.value = arr[1];
        }


        form.value.id = data.id;
      }
    });
    getHistoryVideos( {id: data.id} ).then((res) => {
      historyVideos.value = res.data
    })
  }
  getCarsData();
};
const closeOpen = () => {
  open.value = false;
  formRef.value.resetFields();
};
const cancel = () => {
  console.log("取消");
  open.value = false;
};

const flag = ref(false);
const flag2 = ref(false);
const flag3 = ref(false);
const flag4 = ref(false);
const radioChange = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag.value = true;
  } else {
    flag.value = false;
  }
};
const radioChange2 = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag2.value = true;
  } else {
    flag2.value = false;
  }
};
const radioChange3 = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag3.value = true;
  } else {
    flag3.value = false;
  }
};

const radioChange4 = (e) => {
  console.log(e.target.value);
  if (e.target.value === "0") {
    flag4.value = true;
  } else {
    flag4.value = false;
  }
};

watch(
    () => historyVideos.value,
    (newVal) => {
      if (newVal && newVal.length > 0) {
        console.log('historyVideos数据已更新，数量:', newVal.length);
      }
    },
    { deep: true }
);

const emit = defineEmits(["drawerEvent"]);
// 保存
const confirm = () => {
  console.log("保存");
  console.log("values", form.value);
  const drawerValue = JSON.parse(JSON.stringify(form.value));
  if (drawerValue.departureScene === "0" && userInput.value !== "") {
    drawerValue.departureScene =
      drawerValue.departureScene + "_" + userInput.value;
  }

  if (
    drawerValue.departureMajorParticipant === "0" &&
    userInput2.value !== ""
  ) {
    drawerValue.departureMajorParticipant =
      drawerValue.departureMajorParticipant + "_" + userInput2.value;
  }

  if (drawerValue.departureMajorFacility === "0" && userInput3.value !== "") {
    drawerValue.departureMajorFacility =
      drawerValue.departureMajorFacility + "_" + userInput3.value;
  }

  if (drawerValue.departureReason === "0" && userInput4.value !== "") {
    drawerValue.departureReason =
      drawerValue.departureReason + "_" + userInput4.value;
  }


  emit("drawerEvent", drawerValue);
  open.value = false;
};
// 取消
const cancelDrawer = () => {
  console.log("取消");
  open.value = false;
};
// 使用 defineExpose 向外暴露指定的数据和方法
defineExpose({
  showDrawer,
});
</script>
<style lang="less" scoped>
.first_title {
  color: rgba(29, 33, 41, 0.7);
  font-weight: 600;
  font-size: 18px;
}

.drawer_content {
  padding-left: 46px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #1d2129;
}

.left_ant_right {
  display: flex;
  align-items: center;
  margin-bottom: 23px;

  .left {
    width: 190px;
    text-align: right;
  }

  .right {
    width: 700px;
    margin-left: 32px;
  }
}

.message {
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ff0000;
  line-height: 16px;
  margin-left: 168px;
}

.video-area-main-body {
  width: 70%;
  // height: 300px;
  // background: skyblue
}

/deep/.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background: #f2f4f7;
}

/deep/ .ant-drawer .ant-drawer-footer {
  display: flex;
  justify-content: center;
  border-top: 0px;
  margin-bottom: 50px;
}

/deep/ .ant-drawer .ant-drawer-header {
  border-bottom: 0px;
}

/deep/.ant-drawer-title {
  color: rgba(29, 33, 41, 1);
  font-weight: 600;
  font-size: 18px;
}

/deep/.ant-radio-wrapper span.ant-radio+* {
  width: 114px;
}

/deep/.ant-radio-wrapper {
  margin-bottom: 24px;
}

.old_inp {
  /* 移除原生边框 */
  border: none;
  /* 添加新边框*/
  border-bottom: 1px solid #000;
  /* 左侧内边距 */
  // padding-left: 10px;
  /* 输入框宽度 */
  width: 80px;
  /* 移除点击输入框时浏览器提供的默认轮廓 */
  outline: none;
  position: absolute;
  bottom: 3px;
  left: 70px;
}

/deep/.ant-drawer .ant-drawer-body {
  padding-bottom: 0;
}

/deep/ .ant-tabs-tabpane {
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
  opacity: 1;
  transform: translateX(0);
  position: absolute;
  width: 100%;
}

/deep/ .ant-tabs-tabpane-inactive {
  opacity: 1;
  transform: translateX(0);
  position: absolute;
  width: 100%;
  pointer-events: none;
}

/* 确保标签内容容器有固定高度，防止重绘时布局跳动 */
.tab-content-container {
  min-height: 350px;
  position: relative;
}
</style>
